// extracted by mini-css-extract-plugin
module.exports = {"navigation":"Navigation_navigation__2KfkM","column":"Navigation_column__1-6yk","svg":"Navigation_svg__2x-rn","logo":"Navigation_logo__1hw-T","button":"Navigation_button__13sk5"};